import { i18n } from '@/assets/translations';
import { type GridImages } from '@/interfaces';

type RingRangesNavigation = Readonly<{
  title: string;
  content: string;
  imageDirectoryPath: string;
  extension: string;
  path: { name: string };
  ariaLabel: string;
  altText: string;
  classes?: string;
}>;

export const ringRangesNavigation: ReadonlyArray<RingRangesNavigation> = Object.freeze([
  {
    title: 'homePage.ranges.broknByJ.title',
    content: 'homePage.ranges.broknByJ.content',
    imageDirectoryPath: 'homepage-broknstone-gold',
    extension: 'jpg',
    // « Les Pierres » : page dont le hero est le rubis
    path: { name: `${i18n.global.locale.value}-brokn-by-you` },
    ariaLabel: 'homePage.ranges.broknByJ.title',
    altText: 'images.altText.stoneRed'
  },
  {
    title: 'homePage.ranges.broknByYou.title',
    content: 'homePage.ranges.broknByYou.content',
    imageDirectoryPath: 'homepage-sur-mesure',
    extension: 'jpg',
    // « Sur-mesure » : page dont le hero est la bague flocon
    path: { name: `${i18n.global.locale.value}-brokn-by` },
    ariaLabel: 'homePage.ranges.broknByYou.title',
    altText: 'images.altText.ringSilverBlue'
  },
  {
    title: 'homePage.ranges.broknBy.title',
    content: 'homePage.ranges.broknBy.content',
    imageDirectoryPath: 'homepage-haute-jo',
    extension: 'jpg',
    // « Les Créatrices » : page dont le hero est la bague losange
    path: { name: `${i18n.global.locale.value}-brokn-by-j` },
    ariaLabel: 'homePage.ranges.broknBy.title',
    altText: 'images.altText.ringSilverDiamonds'
  }
]);

type Partner = Readonly<{
  i18nKey: string;
  contents: { i18nKey: string; link?: string }[];
}>;

export const partnersNavigation: ReadonlyArray<Partner> = Object.freeze([
  {
    i18nKey: 'homePage.partners.jewellers',
    contents: [
      { i18nKey: 'homePage.partners.jewellers.content0' },
      { i18nKey: 'homePage.partners.jewellers.content1', link: 'https://swissairland-tech.ch/' },
      {
        i18nKey: 'homePage.partners.jewellers.content2',
        link: 'https://www.lagardejewelrydrawing.fr/'
      },
      { i18nKey: 'homePage.partners.jewellers.content3', link: 'http://www.atelierpaloa.com/' }
    ]
  },
  {
    i18nKey: 'homePage.partners.communication',
    contents: [
      { i18nKey: 'homePage.partners.communication.content0' },
      {
        i18nKey: 'homePage.partners.communication.content1',
        link: 'https://www.instagram.com/mercredie'
      },
      {
        i18nKey: 'homePage.partners.communication.content2',
        link: 'https://www.linkedin.com/in/pauline-benis-087a07106'
      },
      {
        i18nKey: 'homePage.partners.communication.content3',
        link: 'https://www.lakriee-media.ch/%C3%A0-propos'
      }
    ]
  },
  {
    i18nKey: 'homePage.partners.photographers',
    contents: [
      { i18nKey: 'homePage.partners.photographers.content0', link: 'https://felixdupuy.com/' },
      {
        i18nKey: 'homePage.partners.photographers.content1',
        link: 'https://www.laurentxaviermoulin.ch/'
      },
      { i18nKey: 'homePage.partners.photographers.content2', link: 'https://www.adrienplaud.com/' },
      { i18nKey: 'homePage.partners.photographers.content3' }
    ]
  },
  {
    i18nKey: 'homePage.partners.digital',
    contents: [
      { i18nKey: 'homePage.partners.digital.content0', link: 'https://kinoba.fr/' },
      {
        i18nKey: 'homePage.partners.digital.content1',
        link: 'https://www.instagram.com/studioluciole/'
      },
      { i18nKey: 'homePage.partners.digital.content2' }
    ]
  },
  {
    i18nKey: 'homePage.partners.others',
    contents: [
      { i18nKey: 'homePage.partners.others.content0' },
      { i18nKey: 'homePage.partners.others.content1', link: 'https://cafehortus.ch/' }
    ]
  }
]);

export const ourMusesSectionGridImages: GridImages = Object.freeze([
  {
    directoryPath: 'petting-cat',
    extension: 'jpg',
    altText: 'images.altText.peopleWithRing'
  },
  {
    directoryPath: 'brokn-homePage-crossArm',
    extension: 'jpg',
    altText: 'images.altText.peopleWithRing'
  },
  {
    directoryPath: 'smilling-mom',
    extension: 'jpg',
    altText: 'images.altText.peopleWithRing'
  },
  {
    directoryPath: 'brokn-homePage-BackMan',
    extension: 'jpg',
    altText: 'images.altText.peopleWithRing'
  },
  {
    directoryPath: 'hidden-face-man',
    extension: 'jpg',
    altText: 'images.altText.peopleWithRing'
  },
  {
    directoryPath: 'boot-donning',
    extension: 'jpg',
    altText: 'images.altText.peopleWithRing'
  },
  {
    directoryPath: 'cat-and-stare',
    extension: 'jpg',
    altText: 'images.altText.peopleWithRing'
  }
]);
